export const AI_TAGGING_SAMPLES_NEEDED = 10;
